import { AppLayout } from "@/components/AppLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PlaceholderPageProps {
  titleKey: string;
  descriptionKey: string;
}

function PlaceholderContent({
  titleKey,
  descriptionKey,
}: PlaceholderPageProps) {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div className="space-y-6 w-full">
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            {t(`nav.${titleKey}`)}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {t(`placeholder.${descriptionKey}`)}
          </p>
        </div>
        <Card className="shadow-card">
          <CardContent className="p-12 flex flex-col items-center justify-center text-center">
            <div className="h-16 w-16 rounded-2xl bg-secondary flex items-center justify-center mb-4">
              <Construction className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              {t("common.comingSoon")}
            </h3>
            <p className="text-sm text-muted-foreground max-w-md">
              {t("common.comingSoonDesc")}
            </p>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  );
}

// Shared
export const CareerDevelopment = () => (
  <PlaceholderContent
    titleKey="careerDevelopment"
    descriptionKey="careerDevelopment"
  />
);
export const Payroll = () => (
  <PlaceholderContent titleKey="payroll" descriptionKey="payroll" />
);
export const Compliance = () => (
  <PlaceholderContent titleKey="compliance" descriptionKey="compliance" />
);
export const Organization = () => (
  <PlaceholderContent titleKey="organization" descriptionKey="organization" />
);
export const SettingsPage = () => (
  <PlaceholderContent titleKey="settings" descriptionKey="settings" />
);

// Admin-specific
export const UserManagement = () => (
  <PlaceholderContent
    titleKey="userManagement"
    descriptionKey="userManagement"
  />
);
export const AuditLog = () => (
  <PlaceholderContent titleKey="auditLog" descriptionKey="auditLog" />
);
export const SystemSettings = () => (
  <PlaceholderContent
    titleKey="systemSettings"
    descriptionKey="systemSettings"
  />
);

// User / Line Manager
export const TeamPerformance = () => (
  <PlaceholderContent
    titleKey="teamPerformance"
    descriptionKey="teamPerformance"
  />
);
export const Approvals = () => (
  <PlaceholderContent titleKey="approvals" descriptionKey="approvals" />
);

// User / Career Coach
export const Coaching = () => (
  <PlaceholderContent titleKey="coachingDashboard" descriptionKey="coaching" />
);
export const CareerPlans = () => (
  <PlaceholderContent titleKey="careerPlans" descriptionKey="careerPlans" />
);
export const Mentoring = () => (
  <PlaceholderContent titleKey="mentoring" descriptionKey="mentoring" />
);

// User / C-Level
export const Analytics = () => (
  <PlaceholderContent titleKey="analytics" descriptionKey="analytics" />
);
export const Reports = () => (
  <PlaceholderContent titleKey="reports" descriptionKey="reports" />
);
export const StrategicPlanning = () => (
  <PlaceholderContent
    titleKey="strategicPlanning"
    descriptionKey="strategicPlanning"
  />
);
